/**
 * @ignore
 * newRelicInstance
 * @description a helper function to encapsulate accessing the window New Relic object.
 * @returns {object} an object that contains a New Relic instance.
 */
// NOTE guarding for presence of window before trying to access New Relic to avoid uncaught errors
var newRelicInstance = function newRelicInstance() {
  return window && window.newrelic;
};

export default newRelicInstance;
//# sourceMappingURL=newRelicInstance.js.map